if (typeof window.Shopify === 'undefined' || typeof window.Shopify.formatMoney === 'undefined') {
  window.Shopify = window.Shopify || {};
  window.Shopify.formatMoney = function (cents, format) {
    const amount = (cents || 0) / 100;
    const currency = window.Shopify?.currency?.active || 'USD';
    try {
      return (
        new Intl.NumberFormat(navigator.language || 'en-US', {
          style: 'currency',
          currency: currency,
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        }).format(amount) +
        ' ' +
        currency
      );
    } catch (e) {
      return '$' + amount.toFixed(2) + ' ' + currency;
    }
  };
}

if (!customElements.get('product-part')) {
  class ProductPart extends HTMLElement {
    constructor() {
      super();
      this.onQtyChange = this.onQtyChange.bind(this);
    }

    connectedCallback() {
      // Виправлено: правильна назва атрибута
      this.basePriceCents = parseInt(this.dataset.basePriceCents) || 0; // Зміна тут
      this.compareAtPriceCents = parseInt(this.dataset.compareAtPriceCents) || 0;

      this.input = this.querySelector('quantity-input input.quantity__input');
      this.priceContainer = document.getElementById(`price-${this.dataset.productId}-${this.dataset.sectionId}`);

      if (!this.input || !this.priceContainer) {
        console.warn('ProductPart: missing elements for', this.dataset.productId);
        return;
      }

      this.input.addEventListener('change', this.onQtyChange);
      this.input.addEventListener('input', this.onQtyChange);

      this.updatePriceDisplay();
    }

    disconnectedCallback() {
      if (this.input) {
        this.input.removeEventListener('change', this.onQtyChange);
        this.input.removeEventListener('input', this.onQtyChange);
      }
    }

    onQtyChange() {
      this.updatePriceDisplay();
    }

    updatePriceDisplay() {
      const qty = Math.max(1, parseInt(this.input.value || 1));

      const totalCents = this.basePriceCents * qty;
      const compareAtTotalCents = this.compareAtPriceCents * qty;

      const formattedPerItem = window.Shopify.formatMoney(this.basePriceCents, window.theme?.moneyFormat);
      const totalFormatted = window.Shopify.formatMoney(totalCents, window.theme?.moneyFormat);
      const compareAtFormatted =
        compareAtTotalCents > 0 && compareAtTotalCents > totalCents
          ? window.Shopify.formatMoney(compareAtTotalCents, window.theme?.moneyFormat)
          : null;

      const salePriceItem = this.priceContainer.querySelector('.price__sale .price-item--sale');
      const regularPriceItem = this.priceContainer.querySelector('.price__regular .price-item--regular');
      const compareAtElement = this.priceContainer.querySelector('.price__sale s.price-item--regular');
      const unitPriceElement = this.priceContainer.querySelector('.unit-price .price-item--last');

      if (salePriceItem) {
        salePriceItem.textContent = totalFormatted;
      } else if (regularPriceItem) {
        regularPriceItem.textContent = totalFormatted;
      }

      if (compareAtElement) {
        compareAtElement.textContent = compareAtFormatted || '';
      }

      if (unitPriceElement) {
        unitPriceElement.textContent = `${formattedPerItem} each`;
      }
    }
  }

  customElements.define('product-part', ProductPart);
}

if (!customElements.get('product-parts')) {
  class ProductParts extends HTMLElement {
    constructor() {
      super();
      this.onCheckboxChange = this.onCheckboxChange.bind(this);
    }

    connectedCallback() {
      this.buyButtonContainer = document.querySelector('.product__buy .product-form__submit');
      this.productParts = this.querySelectorAll('product-part');
      this.checkboxes = this.querySelectorAll('input[type="checkbox"].product__part-checkbox');
      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      this.iconBuble = document.getElementById('cart-icon-bubble');
      this.notification = document.getElementById('cart-notification');

      if (!this.checkboxes || this.checkboxes.length === 0) {
        console.warn('ProductParts: no checkboxes found');
        return;
      }

      this.checkboxes.forEach((checkbox) => {
        checkbox.addEventListener('change', this.onCheckboxChange);
      });

      this.updateBuyButtonVisibility();
      this.buyButtonContainer.addEventListener('click', this.onSubmitButtonClick.bind(this));
    }

    disconnectedCallback() {
      if (this.checkboxes) {
        this.checkboxes.forEach((checkbox) => {
          checkbox.removeEventListener('change', this.onCheckboxChange);
        });
      }
    }

    onCheckboxChange() {
      this.updateBuyButtonVisibility();
    }

    updateBuyButtonVisibility() {
      if (!this.buyButtonContainer) return;

      const anyChecked = Array.from(this.checkboxes).some((checkbox) => checkbox.checked);

      if (anyChecked) {
        this.buyButtonContainer.classList.remove('hidden');
      } else {
        this.buyButtonContainer.classList.add('hidden');
      }
    }

    async onSubmitButtonClick() {
      const activeProducts = [];

      this.productParts.forEach((productPart) => {
        if (productPart.querySelector('input[type="checkbox"].product__part-checkbox').checked) {
          activeProducts.push(productPart);
        }
      });

      let sections = '';
      let sections_url = '';
      if (this.cart) {
        sections = this.cart.getSectionsToRender().map((section) => section.id);
        sections_url = window.location.pathname;
        this.cart.setActiveElement(document.activeElement);
      }

      this.buyButtonContainer.setAttribute('aria-disabled', true);
      this.buyButtonContainer.classList.add('loading');
      this.buyButtonContainer.querySelector('.loading__spinner').classList.remove('hidden');

      const formData = {
        items: activeProducts.map((productPart) => {
          const quantityInput = productPart.querySelector('quantity-input');
          const variantId = quantityInput?.dataset.variantId;
          const quantity = parseInt(productPart.querySelector('quantity-input input.quantity__input').value);

          return {
            id: Number(variantId),
            quantity: quantity,
          };
        }),
        sections,
        sections_url,
      };

      fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(formData),
      })
        .then((response) => {
          return response.json();
        })
        .then((data) => {
          console.log(data);

          activeProducts.forEach((productPart) => {
            const id = +productPart.dataset.productVariantId;
            data.items.forEach((item) => {
              if (+item.id === id) {
                productPart.querySelector('.quantity__rules-cart').classList.remove('hidden');
                productPart.querySelector('.quantity-cart').textContent = item.quantity;
              }
            });
          });

          this.cart.getSectionsToRender().forEach((section) => {
            document.getElementById(section.id).innerHTML = data.sections[section.id];
          });
          this.cart.open();
        })
        .catch((error) => {
          console.error('Error:', error);
        })
        .finally(() => {
          this.buyButtonContainer.setAttribute('aria-disabled', false);
          this.buyButtonContainer.classList.remove('loading');
          this.buyButtonContainer.querySelector('.loading__spinner').classList.add('hidden');
        });
    }
  }

  customElements.define('product-parts', ProductParts);
}
